// Mobile quick capture lives outside animated routes so scrolling cannot move its fixed position.
import { Plus } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isMainDestination } from '@/lib/appNavigation';

export function CaptureFab() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  if (!isMainDestination(pathname)) return null;
  return <Link to="/capture" data-testid="capture-fab"
    className="fixed z-30 inline-flex h-14 items-center justify-center gap-1.5 rounded-full bg-primary px-4 text-sm font-bold text-primary-foreground shadow-lg hover:bg-primary-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-primary lg:hidden"
    style={{ right: 'max(18px, env(safe-area-inset-right))', bottom: 'calc(5rem + env(safe-area-inset-bottom) + 12px)' }}>
    <Plus className="h-6 w-6" strokeWidth={2.5} aria-hidden />
    {i18n.language.startsWith('en') ? 'Add' : '记一笔'}
  </Link>;
}
